import { uploadFeature } from './upload.reducer';
import * as UploadSelectors from './upload.selectors';
import * as UploadActions from './upload.actions';
import { UploadEffects } from './upload.effects';

export const UploadStore = {
  actions: UploadActions,
  selectors: {
    ...UploadSelectors,
    selectUploadState: uploadFeature.selectUploadState,
    selectUploads: uploadFeature.selectUploads,
  },
  effects: [UploadEffects],
  config: uploadFeature,
};
